import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import axios from 'axios';

const GoogleAuth = () => {
  const handleSuccess = async (credentialResponse) => {
    try {
      const token = credentialResponse.credential;
      const res = await axios.post('https://backend.inkox.com/api/login-with-google', {
        token: token
      });

      if (res.data.status) {
        // Save only name, id, and token in localStorage
        localStorage.setItem('APP_TOKEN', res.data.token);
        localStorage.setItem('Id', res.data.user.id);
        localStorage.setItem('Name', res.data.user.name);

        if (res.data.isNewUser) {
          alert("Welcome! Your account has been created.");
        } else {
          alert("Welcome back!");
        }

        // Refresh the page
  window.location.href = 'https://inkox.com';
      }
    } catch (error) {
      console.error('Google login error', error);
      alert('Login failed. Please try again.');
    }
  };

  return (
    <GoogleLogin
      onSuccess={handleSuccess}
      onError={() => console.log('Google Login Failed')}
    />
  );
};

export default GoogleAuth;
